export enum DepMemberFMY {
Full,
None,
}
